import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import '../styles.css';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation(); // Access the state passed from Login

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setError('Invalid verification link');
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL;
      try {
        const res = await axios.get(`${apiUrl}/api/auth/verify-email`, {
          params: { token },
        });
        console.log('Verification response:', res.data);
        setMessage(res.data.message || 'Email verified successfully');
      } catch (err) {
        console.error('Email verification error:', err.response?.data || err.message);
        setError(
          err.response?.data?.error ||
          err.response?.data?.details ||
          err.message ||
          'An error occurred during email verification. Please try again or contact support.'
        );
      }
    };

    // If there's a message in the state (e.g., from resending verification), display it
    if (location.state?.message) {
      setMessage(location.state.message);
    } else {
      verifyEmail();
    }
  }, [searchParams, navigate, location]);

  const handleOkClick = () => {
    navigate('/login');
  };

  return (
    <div className="page-container auth-page">
      <section className="content-container container my-4 text-center">
        <div className="login-card p-4 mx-auto card-max-width">
          <h2>Email Verification</h2>
          {error && <p className="text-danger">{error}</p>}
          {message && (
            <div>
              <p className="text-success">{message}</p>
              <button className="btn btn-primary mt-3" onClick={handleOkClick}>
                OK
              </button>
            </div>
          )}
          {!message && !error && <p>Verifying your email...</p>}
        </div>
      </section>
    </div>
  );
};

export default VerifyEmail;
